import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ShipmentSpecialFreightTrackingMapFacade } from './shipment-special-freight-tracking-map.facade';
import { switchMap } from 'rxjs/operators';
import { SpecialFreightIdView } from '../../../../models';
import { ShipmentSpecialFreightItemFacade } from '../shipment-special-freight-item.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightTrackingMapGuard {
  constructor(
    private shipmentSpecialFreightTrackingMapFacade: ShipmentSpecialFreightTrackingMapFacade,
    private shipmentSpecialFreightItemFacade: ShipmentSpecialFreightItemFacade,
  ) {}

  canActivate(
    { queryParams: _queryParams }: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    return this.shipmentSpecialFreightItemFacade.specialFreightIdentifier$.pipe(
      switchMap((identifier: SpecialFreightIdView) => {
        return loadStoreState(this.shipmentSpecialFreightTrackingMapFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentSpecialFreightTrackingMapFacade);
  }
}
